module.exports = __webpack_public_path__ + "img/carriers-no-data.54899585.png";